module.exports = __webpack_public_path__ + "media/images/pic/hero/dance-9c53be7124cac837b6cb349d413bce94.jpeg";